import { Injectable } from '@angular/core';

import { AuthenticationService } from '../_services/authenticationService';
import { DataService } from '../_services/data.service';
import { FilterService } from '../_services/filter.service';
import { Config } from '../_store/config';
import { CommonDataService } from '../appDataServices/commonDataService';
import { DateUtilsService } from '../_services/dateUtils';

@Injectable({
  providedIn: 'root'
})
export class CreditNotesService {
  private creditNotesPending: any = {};
  private creditNotesUsed: any = {};

  constructor(
    private dataService: DataService,
    private filterService: FilterService,
    private commonDataService: CommonDataService,
    private dateUtils: DateUtilsService,
    private authenticationService: AuthenticationService
  ) {
  }
//'LABELS.CREDIT_NOTE_DATE'
  sortColumns = {
    'Amount': { col: 'amount' },
    'Credit Note date': { col: 'docDate' },
    'Optimal Selection': { col: '' }
  }

  public getInitConfig() {
    return {
      sortDir: 'desc',
      sortType: 'Amount',
      sortOptions: [
        {
          label : 'LABELS.AMOUNT',
          text : 'Amount'
        },
        {
          label : 'LABELS.CREDIT_NOTE_DATE',
          text : 'Credit Note Date'
        },
        //'Optimal Selection'
      ],
      prevSortType: 'Amount'
    }
  }

  public getCreditNotes(type, options: any = {}) {

    console.log(type);

    let localObj = type === 'USED' ? this.creditNotesUsed : this.creditNotesPending;
    console.log(localObj);

    const req = Object.assign({ type }, this.commonDataService.getRequestWithLastAccessTime(options.hardRefresh ? 0 : localObj.maxDate));
    console.log(req);

    return this.commonDataService.getList(req, 'CREDIT_NOTES_LIST', (data) => {
      console.log("this is credit note obj");
      
      console.log(data);
      
      localObj;
      localObj = this.enhanceCreditNotesList(data, localObj);
      localObj.maxDate = data.serverTime;
      return localObj;
    });
  }

  private enhanceCreditNotesList(serviceResponse, localObj) {
    const currentCNList = localObj.list || [];
    const todayDate = this.dateUtils.getToday();
    const dataMap = {};
    const sellerMap = {};
    const buyerMap = {};
    const uniqueSellers = {};
    const uniqueCNType = {};
    const uniqueCNTags = {};
    if (currentCNList) {
      currentCNList.forEach(item => {
        dataMap[item.docId] = item;
      });
    }
    const receivedItems = Object.keys(serviceResponse.creditNotes);
    receivedItems.forEach(docId => {
      const item = serviceResponse.creditNotes[docId];
      const sellerConfig = (serviceResponse.sellerConfig[item.sellerCode] || {});
      item.sellerNm = sellerConfig.sellerNm;
      item.buyerName = item.buyerName || item.buyerCode;
      item.imgUrl = sellerConfig.sellerImg;
      console.log(item.imgUrl);
      
      const diff = (item.docAmt === item.dueAmt) ? item.dueAmt : (item.docAmt - item.dueAmt)
      item.formattedInCNUsedAmt = this.dataService.displayNumberAsCurrency((diff || 0).toString());
      item.formattedAmount = this.dataService.displayNumberAsCurrency((item.dueAmt || 0).toString());
      const itemDateMoment = this.dateUtils.convertDateUnknownFormat(item.dueDate);
      const cnItemDateMoment = this.dateUtils.convertDateUnknownFormat(item.docDate);

      item.crDate = itemDateMoment.format(Config.dateFormat);
      item.cnDate = cnItemDateMoment.format(Config.dateFormat);
      if (typeof item.imgUrl === 'undefined') {
        item.imgUrl = Config.defaultImage;
      }
      if (!sellerMap[item.sellerNm]) {
        sellerMap[item.sellerNm] = 1;
      }
      if (!buyerMap[item.buyerNameWithCode]) {
        buyerMap[item.buyerNameWithCode] = item.buyerNameWithCode;
      }
      if (dataMap[item.docId]) {
        Object.assign(dataMap[item.docId], item);
      } else {
        currentCNList.push(item);
      }
      item.dateForSort = this.dateUtils.getTimestamp(itemDateMoment);
    });
    currentCNList.forEach(item => {
      item.isVisible = true;
      if (!uniqueSellers[item.sellerNm]) {
        uniqueSellers[item.sellerNm] = item.sellerNm;
      }
      if (item.tags && item.tags.length > 0) {
        item.tags.forEach(tag => {
          if (!uniqueCNType[tag.tag]) {
            uniqueCNType[tag.tag] = tag.tag;
          }
        })
      }
    });
    currentCNList.sort((a, b) => a.dateForSort - b.dateForSort);
    const retData: any = {
      list: currentCNList,
      sellers: Object.keys(uniqueSellers),
      cnTypes: Object.keys(uniqueCNType),
      buyers: Object.keys(buyerMap),
      itemCount: currentCNList.length
    };
    retData.filters = this.getCNFilters(retData);
    return retData;
  }

  private getCNFilters(itemData) {
    const amountProp = 'dueAmtDetails';
    const sellerObj = {
      company: {
        rules: itemData.sellers.map((sellerName) => {
          return {
            label: sellerName,
            fn: item => item.sellerNm === sellerName
          }
        }).sort((a, b) => {
          if (a.label < b.label)
            return -1;
          if (a.label > b.label)
            return 1;
          return 0;
        }),
        label: 'LABELS.SELLERS',
        amountProp: amountProp,
        resetFilters: true
      },
      'buyers': {
        rules: itemData.buyers.map((buyerNameWithCode) => {
          return {
            label: buyerNameWithCode,
            fn: item => item.buyerNameWithCode === buyerNameWithCode
          };
        }).sort((a, b) => {
          if (a.label < b.label)
            return -1;
          if (a.label > b.label)
            return 1;
          return 0;
        }),
        label: 'LABELS.BUYER(S)',
        amountProp: amountProp
      },
      type: {
        rules: itemData.cnTypes.map((cnType) => {
          return {
            label: cnType,
            fn: item => item.tags.find(tag => tag.tag === cnType)
          };
        }),
        label: 'LABELS.TYPE',
        amountProp: amountProp,
        resetFilters: true
      },
      docSearch: {
        isValueFilter: true,
        rules: [{
          label: 'Document Search',
          fn: (item, val) => {
            return item.docNo.toString().toLowerCase().indexOf(val.toLowerCase()) !== -1;
          }
        }],
        label: 'Document Search',
        amountProp: amountProp
      },
    };
    const isSalesmanLogin = this.authenticationService.isCurrentUserSalesman();
    const filtersObj = Object.assign({}, sellerObj);
    return this.filterService.createFilters(itemData.list, filtersObj, 'docId');
  }


  public sortCreditNotes(sortConfig, creditNotes, bankAmt, cnGreaterThanInvoice = false) {
    if (sortConfig.prevSortType === sortConfig.sortType) {
      sortConfig.sortDir = (sortConfig.sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      sortConfig.sortDir = 'asc';
      sortConfig.prevSortType = sortConfig.sortType
    }
    const sortColumn = this.sortColumns[sortConfig.sortType];
    if (sortColumn && sortColumn.col) {
      creditNotes.sort((a, b) => {
        const aVal = a[sortColumn.col];
        const bVal = b[sortColumn.col];
        return (aVal === bVal ? 0 : (sortConfig.sortDir === 'asc' ? (aVal < bVal ? -1 : 1) : (aVal < bVal ? 1 : -1)));
      });
    } else {
      // sort by custom knapsack
      this.arrangeCreditNotesByBalance(creditNotes, bankAmt, 0)
      creditNotes.sort((a, b) => {
        const aVal = a.pos || Number.MAX_VALUE;
        const bVal = b.pos || Number.MAX_VALUE;
        return (aVal === bVal ? 0 : (aVal < bVal ? -1 : 1));
      });
      //this.sortCreditNotesAscendingBasedOnBalance(creditNotes);
    }
  }

  private arrangeCreditNotesByBalance(creditNotes, bankAmt, pos) {
    this.getBalanceCNamtDiff(creditNotes, bankAmt);
    this.sortCreditNotesAscendingBasedOnBalance(creditNotes);
    const balance = bankAmt - creditNotes[0].CN_BALANCE;
    creditNotes[0].pos = pos;
    if (creditNotes[1] && balance > 0) {
      this.arrangeCreditNotesByBalance(creditNotes.slice(1), balance, pos + 1);
    }
  }

  private sortCreditNotesAscendingBasedOnBalance(creditNotes) {
    creditNotes.sort((a, b) => {
      const aVal = a.diff;
      const bVal = b.diff;
      return (aVal === bVal ? 0 : (aVal < bVal ? -1 : 1));
    });
  }

  private getBalanceCNamtDiff(creditNotes, balanceAmt) {
    creditNotes.forEach(item => {
      item.diff = balanceAmt - (item.CN_BALANCE);
      if (item.diff < 0) {
        item.diff = Number.MAX_VALUE;
      }
    });
  }

}
